import { CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

const getAuthorRecoV3Service = (
  params: { ids: string[]; nbrecos?: number },
  cancelToken?: CancelToken,
): Promise<any> =>
  apiInstance.get(ApiPathConfig.AUTHOR_RECO_V3_WITH_EANS(params), {
    cancelToken,
  })

export default getAuthorRecoV3Service
